export interface GetUserListPagingAndFilterResponse {
    isSuccess: boolean
    message: any
    data: GetUserListPagingAndFilterResponseData
}

export interface GetUserListPagingAndFilterResponseData {
    items: GetUserListPagingAndFilterResponseItem[]
    totalRecordCount: number
}

export interface GetUserListPagingAndFilterResponseItem {
    userId: string
    userNameSurname: string
    userEmail: string
    userPhone: string
    userUsername: string
    userRoles: GetUserListPagingAndFilterResponseUserRole[]
    userCompany: GetUserListPagingAndFilterResponseUserCompany
    createdDate: string
    createdUser: string
    updatedDate: string
    updatedUser: string
    isSelected: boolean
}

export interface GetUserListPagingAndFilterResponseUserRole {
    roleId: string
    roleName: string
}

export interface GetUserListPagingAndFilterResponseUserCompany {
    companyId: string
    companyName: string
}

export const initialGetUserListPagingAndFilterResponseData: GetUserListPagingAndFilterResponseData = {
    items: [],
    totalRecordCount: 0
}